import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import { Route, Switch, withRouter } from 'react-router-dom';
import { isStaff } from '../../helpers/global';
import NotFound from '../NotFound';
import SearchTasks from './SearchTasks';

const Tasks = () => {
  const [role] = useState(localStorage.getItem('user-role'));

  if (!isStaff(role)) return <NotFound />;

  const getActivePage = () => {
    return (
      <Switch>
        <Route exact path="/tasks">
          <SearchTasks />
        </Route>
        <Route path="*">
          <NotFound />
        </Route>
      </Switch>
    );
  };
  return (
    <Container fluid className="px-2 px-lg-5 h-100">
      {getActivePage()}
    </Container>
  );
};

export default withRouter(Tasks);
